export default "__VITE_ASSET__93d362b0__"